export default "__VITE_ASSET__kYi6th7L__"